import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Link } from "react-router-dom";
import UISearchDropdown from "components/UI/SearchDropdown";
import WidgetHeader from "components/WidgetHeader/WidgetHeader";
import styles from "./InfoPanel.module.css";
import "../../../css/flex.css";

const DropdownSpan = styled.span`
  margin: 0 0 -12px 0;
  font-size: 16px;
  font-weight: 700;
`;

class InfoPanel extends React.Component {
  componentDidMount() {
    this.props.fetchData();
  }

  render() {
    const {
      listItems,
      stateDetails,
      disableStart,
      stateName,
      onSelection,
      className
    } = this.props;

    let txt = stateName
      ? "The below information is needed to complete " +
        stateName +
        " Fee Report:"
      : null;

    const payTypeIdx = stateDetails.findIndex(x => /^pay type/i.test(x));
    const payType = payTypeIdx >= 0 && stateDetails[payTypeIdx].split(":")[1];
    const listStateDetails = [...stateDetails];
    payTypeIdx >= 0 && listStateDetails.splice(payTypeIdx, 1);

    return (
      <section className={`${styles.base} ${className}`}>
        <WidgetHeader title="New Report" />
        <div className={styles.content}>
          <p className={styles.intro}>
            To start a new fee report please select a State below and click
            "Start"
          </p>
          <DropdownSpan>State</DropdownSpan>
          <UISearchDropdown
            onSelection={onSelection}
            placeholder="Select"
            items={listItems}
            containerProps={{ className: "states-dropdown" }}
            data-state-dropdown
            id="select_state"
          />
          <div className={styles.flexContent} data-state-details>
            <p className={styles.intro}>{txt}</p>
            <ul className={styles.stateDetails}>
              {payType ? (
                <li style={{ listStyle: "none" }}>
                  Pay Type:{" "}
                  <span style={{ fontWeight: "bold" }}>{payType}</span>
                </li>
              ) : null}

              {listStateDetails.map((item, i) => (
                <li id={`${item}_id`} key={i}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        <Link
          name="Start Info Panel"
          id="startInfoPanel"
          to="/questionnaire"
          className={`${styles.startLink} ${
            disableStart ? styles.disableBtn : ""
          }`}
        >
          <footer className={styles.footer} data-start-btn>
            Start
          </footer>
        </Link>
      </section>
    );
  }
}

InfoPanel.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  stateDetails: PropTypes.array,
  disableStart: PropTypes.bool,
  stateName: PropTypes.string,
  onChange: PropTypes.func,
  onSelection: PropTypes.func,
  className: PropTypes.string
};

InfoPanel.defaultProps = {
  className: "",
  onChange: () => {},
  onSelection: () => {}
};

export default InfoPanel;
